export interface AutocompleteOption {
	value: string;
	label: string;
}

export interface AutocompleteOptionGroup extends AutocompleteOption {
	options: Array<AutocompleteOption>;
}
